import React, {useState} from "react"
import {Image, message, Modal} from "antd"
import './ComplaintDetail.css'
import moment from "moment"
import {getComplaintDetail} from "../../../api/complaintManager"
import ClubComplaintHandle from "./ClubComplaintHandle";
import ComplaintDetailOrder from "./ComplaintDetailOrder";

/**
 * 投诉详情
 */
const ClubComplaintDetail = ({record}) => {

    const [showModal, setShowModal] = useState(false)
    const [detail, setDetail] = useState({})
    const [progress, setProgress] = useState([])
    const [order, setOrder] = useState(null)

    const showDetail = async () => {
        try {
            setShowModal(true)
            const res = await getComplaintDetail(record.serialNumber)
            if (res.status !== 1) {
                setShowModal(false)
                message.error("获取投诉详情异常")
                return
            }
            setDetail(res.data.complaint)
            setOrder({...res.data.bill})
            setProgress(res.data.progress)
        } catch (e) {
            setShowModal(false)
            message.error("获取投诉详情异常")
        }
    }

    /**
     * 根据updateTime获取48小时后的时间
     */
    const getEstimatedCompletionTime = () => {
        let time = moment(record.updateTime).add(48, 'hours').format('YYYY-MM-DD HH:mm')
        if (record.status === 1 || record.status === 4) {
            return `预计将在 ${time} 前处理完毕`
        }
        return `请在 ${time} 前处理完毕`
    }

    /**
     * 从字符串中提取列表
     */
    const getListFromString = (str) => {
        return str.split(',').filter(item => item.trim() !== '')
    }

    /**
     * 检查当前状态是否属于处理中
     */
    const checkStatus = () => {
        return [0, 1, 4, 5].includes(record.status)
    }

    const checkStatusBtn = () => {
        return record.status === 0 || record.status === 5
    }

    /**
     * 根据progress来获取当前状态文本
     *
     * @description 对照sportleague-server项目下的枚举类
     * （1）ComplaintStatusTypes
     * （2）ComplaintFormTypes
     */
    const getPostStatusText = (item) => {
        const statusMap = {
            '0,0': '用户发起投诉，待俱乐部回应',
            '1,1': '俱乐部已回应，待用户确认',
            '2,0': '用户已申请平台协助',
            '3,0': '用户认可结果，投诉完结',
            '3,3': '用户超时未处理，投诉完结',
            '4,2': '待用户补充凭证',
            '5,2': '待俱乐部补充凭证',
            '6,0': '用户撤销投诉',
            '7,0': '超时关闭',
        }

        const specialCases = {
            '4,2,0': '用户已补充凭证，待平台处理',
            '5,2,1': '俱乐部已补充凭证，待平台处理',
            '1,7,3': '用户超时未确认处理结果，投诉关闭',
            '2,7,3': '用户超时未确认处理结果，投诉关闭',
            '4,7,3': '用户超时不处理补充凭证，投诉关闭',
            '5,7,3': '俱乐部超时未处理补充凭证，投诉关闭',
            '2,3,2': '平台已核实，投诉完结',
            '0,2,3': '俱乐部超时未处理，已移交至平台'
        }

        const key = `${item.preStatus},${item.postStatus},${item.type}`
        if (specialCases[key]) {
            return specialCases[key]
        }
        return statusMap[`${item.postStatus},${item.type}`] || '未知状态'
    }

    return (
        <div className='union-complaint-detail-page'>
            <a type={"primary"} onClick={() => showDetail()}>查看详情</a>
            {
                <Modal title="投诉详情" open={showModal} width={1300} closable={true} footer={null}
                       onCancel={() => setShowModal(false)}>
                    <div className='union-complaint-detail'>
                        {
                            checkStatus() && (
                                <div className='union-complaint-header'>
                                    <div className='id'>投诉ID：{record.id}</div>
                                    <div className='time'>{getEstimatedCompletionTime()}</div>
                                </div>
                            )
                        }

                        {order && <ComplaintDetailOrder order={order} type={detail.businessType}/>}

                        <div className='union-complaint-content'>
                            <div className='complaint-info'>
                                <div className='info-title'>投诉信息</div>
                                <div className='info-item'>
                                    <div className='item-title'>投诉类型</div>
                                    <div
                                        className='item-content'>{record.type === 0 ? '订单问题' : '球房服务问题'}</div>
                                </div>
                                <div className='info-item'>
                                    <div className='item-title'>投诉内容</div>
                                    <div
                                        className='item-content'>{progress.length > 0 && progress[progress.length - 1].content}</div>
                                </div>
                                <div className='info-item'>
                                    <div className='item-title'>消费金额</div>
                                    <div className='item-content'>&yen; {(record.cost / 100).toFixed(2)}</div>
                                </div>
                                <div className='info-item'>
                                    <div className='item-title'>联系电话</div>
                                    <div className='item-content'>{record.phoneNumber}</div>
                                </div>
                                <div className='info-item'>
                                    <div className='item-title'>投诉时间</div>
                                    <div
                                        className='item-content'>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</div>
                                </div>

                                <div className="btn-list">
                                    <ClubComplaintHandle record={record} disabled={!checkStatusBtn()} />
                                </div>
                            </div>

                            <div className='complaint-progress'>
                                <div className='progress-title'>投诉进度</div>
                                <div className='progress-list'>
                                    {
                                        progress.map((item, index) => (
                                            <div className='progress-item' key={index}>
                                                <div className='item-title'>{getPostStatusText(item)}</div>
                                                <div className='item-subtitle'>
                                                    {moment(item.operatorTime).format('YYYY/MM/DD HH:mm:ss')}
                                                    {
                                                        item.type !== 0 && (
                                                            <div style={{
                                                                marginLeft: '20px',
                                                                fontSize: '12px'
                                                            }}>处理人：{item.operatorName}</div>
                                                        )
                                                    }
                                                </div>
                                                {
                                                    (item.content != null && item.content != '' || item.photos != null && item.photos != '') && (
                                                        <div className='item-content'>
                                                            {
                                                                item.content != null && item.content != '' && (
                                                                    <div className='content-detail'>
                                                                        <div className='content-detail-left'>详情</div>
                                                                        <div
                                                                            className='content-detail-right'>{item.content}</div>
                                                                    </div>
                                                                )
                                                            }
                                                            {
                                                                item.photos != null && item.photos != '' && (
                                                                    <div className='content-photos'>
                                                                        <div className='content-detail-left'>图片证明</div>
                                                                        <div className='content-detail-right'>
                                                                            {
                                                                                getListFromString(item.photos).map((photo, index) => (
                                                                                    <Image key={index} src={photo}
                                                                                           style={{
                                                                                               width: '60px',
                                                                                               height: '60px'
                                                                                           }}/>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
        </div>
    )
}

export default ClubComplaintDetail


// WEBPACK FOOTER //
// ./src/containers/ClubComplaintManager/component/ClubComplaintDetail.js